const FULL_ACCESS_TYPES = new Set(["OWN/DIREKSI", "MGR", "MANAGER"]);

const MENU_ACCESS_BY_TYPE = {
  SPV: "namaPemohon",
  "SPV/KOMITE": "namaPemohon",
  "KOMITE/SPV": "namaPemohon",
  ADM: "admin",
  ADMIN: "admin",
  SUR: "permohonan",
  SURVEYOR: "permohonan",
  VERIFIKATOR: "dataVerifikasi",
  "ADMIN VERIFIKATOR": "validasiDataVerifikator",
  EKS: "daftarKunjungan",
  "KOLEKTOR": "daftarKunjungan",
};

export const allMenuAccessKeys = [
  "surveyor",
  "kolektor",
  "permohonan",
  "namaPemohon",
  "admin",
  "dataVerifikasi",
  "validasiDataVerifikator",
  "daftarKunjungan",
  "profilUser",
  "daftarUser",
  "setting",
];

const LEGACY_ACCESS_KEYS = {
  dataVerifikasi: "verifikator",
  validasiDataVerifikator: "adminVerifikator",
  daftarKunjungan: "surveyKolektor",
};

export const hasFullMenuAccess = (tipeUser) => {
  return FULL_ACCESS_TYPES.has(tipeUser);
};

export const getSelectableMenuAccess = (tipeUser) => {
  if (hasFullMenuAccess(tipeUser)) {
    return allMenuAccessKeys;
  }

  const relatedMenu = MENU_ACCESS_BY_TYPE[tipeUser];
  return relatedMenu ? [relatedMenu, "profilUser"] : ["profilUser"];
};

export const canUserAccessMenu = (user, menuAccess) => {
  if (!menuAccess) {
    return true;
  }

  if (hasFullMenuAccess(user?.tipeUser)) {
    return true;
  }

  if (menuAccess === "profilUser") {
    return true;
  }

  const relatedMenu = MENU_ACCESS_BY_TYPE[user?.tipeUser];
  return (
    relatedMenu === menuAccess &&
    (user?.akses?.[menuAccess] === true ||
      user?.akses?.[LEGACY_ACCESS_KEYS[menuAccess]] === true)
  );
};
